import React, { forwardRef } from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './button.style';
import { Colors, Sizes, Variants } from './types';

const DEFAULT_ICON_STROKE_WIDTH = 1.5;

export type ButtonProps = React.ComponentProps<'button'> & {
  startIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  endIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconStrokeWidth?: number;
  variant?: Variants;
  color?: Colors;
  size?: Sizes;
  fullWidth?: boolean;
  alignCenter?: boolean;
  disabledBackgroundOnly?: boolean;
  preventDrag?: boolean;
  selected?: boolean;
  as?: React.FC | string;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      startIcon,
      endIcon,
      iconStrokeWidth = DEFAULT_ICON_STROKE_WIDTH,
      size = Sizes.Large,
      variant = Variants.Contained,
      color = Colors.Primary,
      fullWidth,
      alignCenter,
      disabledBackgroundOnly,
      children,
      preventDrag,
      selected,
      as,
      ...rest
    },
    ref,
  ) => (
    <Styled.Button
      {...rest}
      ref={ref}
      $size={size}
      $color={color}
      $variant={variant}
      $fullWidth={!!fullWidth}
      $alignCenter={!!alignCenter}
      $disabledBackgroundOnly={!!disabledBackgroundOnly}
      $preventDrag={!!preventDrag}
      $selected={!!selected}
      as={as}
    >
      {!!startIcon && (
        <Styled.IconContainer $size={size}>
          <Icon icon={startIcon} strokeWidth={iconStrokeWidth} />
        </Styled.IconContainer>
      )}
      {children}
      {!!endIcon && (
        <Styled.IconContainer $size={size}>
          <Icon icon={endIcon} strokeWidth={iconStrokeWidth} />
        </Styled.IconContainer>
      )}
    </Styled.Button>
  ),
);
